import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { BaseApiService } from '../base-api.service';
import { UserService } from '../user/user.service';

@Injectable({
  providedIn: 'root',
})
export class DashboardService {
  token = '';
  baseUrl = window.location.origin;

  constructor(
    private baseAPIService: BaseApiService,
    public user: UserService,
  ) {
    this.user.token.subscribe(value => {
      this.token = value;
    });
  }

  getRelationshipCount(): Promise<RelationshipCount> {
    const url = this.baseUrl + '/api/Dashboard/GetRelationshipCount';
    this.baseAPIService.headerToken = this.token;
    const result = this.baseAPIService.get<RelationshipCount>(url);
    return result;
  }
}

//create reports object
export class RelationshipCount {
  public uniqueRelationshipCount: string;
  public biDiretionalRelationshipCount: string;
  public derivedSourceRelationshipCount: string;
  public lastRefreshedDate: string;
  public differingUnspscCount: string;
}
